/**
 * @export
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function initDetail(state, action) {
	const { prefix, fields, buttons, timeline, subpanels, extraData } = action.payload;

	if (prefix === 'view') {
		return {
			...state,
			view: {
				...state.view,
				detail: {
					...state.view.detail,
					fields,
					buttons,
					changes: {},
					timeline,
					subpanels,
					extraData,
				},
			},
		};
	} else if (prefix.startsWith('popups/')) {
		const popupIndex = parseInt(prefix.split('/')[1], 10);

		if (!isNaN(popupIndex) && popupIndex >= 0 && popupIndex < state.popups.length) {
			const updatedPopups = [...state.popups];
			updatedPopups[popupIndex] = {
				...updatedPopups[popupIndex],
				detail: {
					...updatedPopups[popupIndex].detail,
					fields,
					buttons,
					changes: {},
					timeline,
					subpanels,
					extraData,
				},
			};

			return {
				...state,
				popups: updatedPopups,
			};
		}
	}

	return state;
}
